import { useMemo } from 'react';
import { useTheme } from '@mui/material';

/**
 * Shared DayPicker inline styles for custom date range dialogs (fixed range and until-now).
 * Used by CustomFixedRangePicker and SingleDatePicker.
 */
export function useSharedDayPickerStyles() {
  const theme = useTheme();

  return useMemo(
    () => ({
      month_caption: {
        fontWeight: 500,
        color: theme.palette.text.primary,
        textTransform: 'capitalize' as const,
      },
      weekday: {
        textTransform: 'uppercase' as const,
      },
      selected: {
        fontWeight: 500,
      },
      range_start: {
        fontWeight: 500,
      },
      range_middle: {
        fontWeight: 500,
      },
      range_end: {
        fontWeight: 500,
      },
    }),
    [theme],
  );
}
